const CONNECT_INFO = {
    GOOD: {
        COLOR: '#1EC26A',
        TITLE: 'connectInfo.good',
        NAME: 'GOOD'
    },
    NONOPTIMAL: {
        COLOR: '#EE5F00',
        TITLE: 'connectInfo.nonOptimal',
        NAME: 'NONOPTIMAL'
    },
    POOR: {
        COLOR: '#EE0033',
        TITLE: 'connectInfo.poor',
        NAME: 'POOR'
    },
    LOSS: {
        COLOR: '#949595',
        TITLE: 'connectInfo.loss',
        NAME: 'LOSS'
    }
}

export { CONNECT_INFO }
